import { useNavigate } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../schema.dexie";
import { calcularDerivadosAtividade } from "../domain";
import { listarAtividades } from "../queries";
import type { AtividadePsicomotora } from "../types";
import { AtividadeFoto } from "../ui/AtividadeFoto";

/**
 * P0.5 — kit rápido: atalho às atividades por efeito regulatório tônico e favoritas.
 * "Preciso acalmar agora" em ≤2 toques. Tocar a linha abre o registro. O eixo de
 * regulação é o mesmo do Compasso — a integração (§14) cruzará música + movimento.
 */
export function KitCorpo() {
  const nav = useNavigate();
  const atividades = useLiveQuery(() => listarAtividades()) ?? [];
  const momentos = useLiveQuery(() => db.momento_psm.toArray()) ?? [];

  const ativas = atividades.filter((a) => a.status !== "sensivel");
  const efeito = (a: AtividadePsicomotora) =>
    calcularDerivadosAtividade(a.id, momentos).efeito_regulatorio;

  const acalmar = ativas.filter((a) => ["acalma", "regula"].includes(efeito(a)));
  const ativar = ativas.filter((a) => efeito(a) === "ativa");
  const favoritas = ativas.filter((a) => a.status === "favorita");

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>
        ← voltar
      </button>
      <h1 className="tela-titulo">kit rápido</h1>
      <p className="tela-sub">o que costuma funcionar, à mão. derivado dos momentos registrados.</p>

      <Grupo
        titulo="🌙 preciso acalmar agora"
        vazio="ainda sem atividades que tendem a acalmar — registre a regulação (antes/depois) pra descobrir."
        lista={acalmar}
        onAbrir={(id) => nav(`/gingado/registrar/${id}`)}
      />
      <Grupo
        titulo="⚡ preciso ativar agora"
        vazio="ainda sem atividades que tendem a ativar."
        lista={ativar}
        onAbrir={(id) => nav(`/gingado/registrar/${id}`)}
      />
      <Grupo
        titulo="★ favoritas"
        vazio="marque atividades como favoritas para vê-las aqui."
        lista={favoritas}
        onAbrir={(id) => nav(`/gingado/registrar/${id}`)}
      />
    </main>
  );
}

function Grupo({
  titulo,
  vazio,
  lista,
  onAbrir,
}: {
  titulo: string;
  vazio: string;
  lista: AtividadePsicomotora[];
  onAbrir: (id: string) => void;
}) {
  return (
    <section className="secao">
      <h2 className="secao-titulo">{titulo}</h2>
      {lista.length === 0 ? (
        <div className="card" style={{ color: "var(--text-muted)" }}>
          {vazio}
        </div>
      ) : (
        lista.map((a) => (
          <button className="card linha-alimento" key={a.id} onClick={() => onAbrir(a.id)}>
            <AtividadeFoto midias={a.midias} nome={a.nome} tipo={a.tipo} />
            <div className="crescer">
              <div className="nome">{a.nome}</div>
              {a.seguranca && (
                <div className="meta" style={{ color: "var(--text-suave)" }}>
                  ⚠️ {a.seguranca}
                </div>
              )}
            </div>
            <span aria-hidden>🤸</span>
          </button>
        ))
      )}
    </section>
  );
}
